const { text, url, routes } = window;

export default ({libraryName, newLibraryName, newLibraryURL, siteMessage, logo, lessData, isMergedSite, isTerminatedSite}) => `
<div class="Header">
    <div class="LibraryLogoContainer">
        <a aria-label="${ html('libraryTitle', {libName: libraryName}) }" href="${ url(routes.home) }">
            <img onerror="showAltLogoDesktop();" class="logo"  tabindex="-1" aria-hidden="true" alt="${ html('nav.logo', {libraryName: libraryName}) }" src="${ logo }"/>
        </a>
    </div>
</div>

<div class="DefunctSite-MessageBody">
    <div class="messageContainer">
        <div tabindex="0" class="message">
            ${isMergedSite ?
                `${lessData ? 
                    `<h4>${html("mergedSite.mergedLibraryWithoutLink", {libraryName: libraryName})}</h4>`
                    : 
                    `<h4>${text("mergedSite.mergedLibraryWithLink", {libraryName: libraryName, link: `<a href="${newLibraryURL}">${newLibraryName}</a>`})}
                    ${ siteMessage 
                        ? 
                    `</h4>
                    <h4>${siteMessage}</h4>
                    <h4>`: ``}
                    ${text("mergedSite.getAccess", {libraryName: libraryName, link: `<a href="${newLibraryURL}">${text("mergedSite.librarysCollection", {libraryName: newLibraryName})}</a>`})} </h4>`
                }`
                : ``
            }
            ${isTerminatedSite ? 
                `<h4>${text("terminatedSite.noDigitalTitles", {libraryName: libraryName})}</h4>
                <h4>${text("terminatedSite.findLibrary")}</h4>` : ``}
        </div>
    </div>
</div>
`;